import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HomeListItem from '../../shared/HomeListItem/home.list.item.vue';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CallNative } from '../../../services/EpicContextService/call.native';

@Component({
    components: {
        HomeListItem
    }
})
export default class ListingPresentationMobileCompare extends Vue {
    public data: string = '';
    public selected: number[] = [];
    public limit_sum = 5;
    public homeList: any[] = [];
    public configs = new CommonConfig();
    public stats = [];
    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
    public selectHome(id: number) {
        if (this.selected.indexOf(id) !== -1) {
            this.selected = this.selected.filter(v => v !== id);
        } else {
            if (this.selected.length === this.limit_sum) {
                this.$Notice.warning({
                    title: '提醒',
                    desc: `最多选择${this.limit_sum}个房源`
                });
                return;
            }
            this.selected.push(id);
        }
    }
    public async created() {
        const apiHost = this.configs.cmaHost;
        const propertyInfo = this.$store.state.lpMobile.params.propertyInfo;
        const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/cma/report`, {
            propertyType: propertyInfo.propertyType,
            bedrooms: propertyInfo.bedrooms,
            washrooms: propertyInfo.washrooms,
            garages: propertyInfo.garages,
            address: this.$store.state.lpMobile.params.subjectSearchText,
            matchStreetLimit: 20,
            matchTimespanLimit: 20,
            simThreshhold: 0
        });
        if (fetched.status === 200) {
            if (Object.keys(fetched.data.comparitives).length === 0) {
                this.$Notice.error({
                    title: '地址信息不正确',
                    desc: `地址周围无住房信息`
                });
                return;
            }
            for (const key in fetched.data.comparitives) {
                if (fetched.data.comparitives[key]) {
                    this.homeList.push(fetched.data.comparitives[key]);
                }
            }
            this.stats = fetched.data.stats ? fetched.data.stats : [];
        } else {
            this.$Notice.error({
                title: '失败',
                desc: `网络问题， 请稍后重试`
            });
            return;
        }
    }
    public mounted() {
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeSetNavTitle, {
            'title_cn': '生成报告',
            'title_en': 'New Presentation',
        });
    }
    public handleSubmit() {
        const comparatives = this.homeList.filter((v: any) =>
            this.selected.indexOf(v._id) !== -1
        );
        this.$store.commit('lpMobileSetComparitives', comparatives);
        this.$store.commit('lpMobileSetStats', this.stats);
        this.$router.push('/hybrid/listing-presentation/generator');
    }
}
